<lib-table [tableColumns]="organisationInvoicesColumns" [api]="api" [title]="title" [exportButton]="exportButton"
    [tabData]="tabData" [searchUIOptions]="searchUIOptions" [resourceMessages]="resourceMessages"
    [addNewButton]="addNewButton" (smHandleUpdateButtonClick)="handleUpdateButtonClick($event)"></lib-table>